import React from "react";

function Goatee2() {
  return (
    <>
      <path
        className="hairMediumShade"
        d="m 293.28503,390.81017 -31.16827,-26.52658 a 4.6603268,4.6603268 0 0 0 -6.00249,0 l -30.81408,26.50794 a 43.807071,43.807071 0 0 0 33.806,26.35881 0.57788051,0.57788051 0 0 0 0.18642,0 0.5219566,0.5219566 0 0 0 0.18642,0 43.807071,43.807071 0 0 0 33.806,-26.34017 z"
        id="path2070"
      />
    </>
  );
}

export default Goatee2;
